import helper from "@/utils/helper";
export default (theme) => ({
  g_layout: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    background: theme.palette.commonBg,
  },
  g_content_box: {
    flex: 1,
    display: "flex",
    alignItems: "stretch",
    marginTop: 80,
    maxWidth: "100%",
    overflowX: "hidden",
    "@media screen and (max-width:800px)": {
      marginTop: 64,
    },
  },
  g_content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    minWidth: 0,
    overflowX: "hidden",
  },
  g_content_child: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    width: "100%",
  },
  g_con: {
    flex: 1,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflowX: "hidden",
  },
  g_table_box: {},
  g_svg_stroke: {
    "& *": {
      stroke: theme.palette.text[100],
    },
  },
  g_table: {
    borderRadius: 16,
    background: theme.palette.grey[700],
    padding: "8px 0px",
    "@media screen and (max-width:1024px) and (min-width:800px)": {
      minWidth: 800,
    },
    "@media screen and (max-width:800px)": {
      background: "none",
    },
  },
  g_table_title: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    height: 48,
    padding: "0 24px",
    "& > div": {
      flex: 1,
      color: theme.palette.grey[300],
      fontSize: 14,
      fontWeight: 500,
    },
  },
  g_greybtn: {
    borderRadius: 8,
    background: "#3D3E49",
    color: "#F0F2F5",
    "&:hover": {
      background: "#3D3E49",
      opacity: 0.9,
      color: "#F0F2F5",
    },
  },
  g_primarybtn: {
    borderRadius: 8,
    background: helper.hex_to_rgba(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
    "&:hover": {
      background: helper.hex_to_rgba(theme.palette.primary.main, 0.1),
      color: theme.palette.primary.main,
    },
  },
  g_table_con: {
    "& > div": {
      height: 56,
      display: "flex",
      alignItems: "center",
      gap: 16,
      padding: "0 24px",
      "& .g_action": {
        cursor: "pointer",
      },
      "&:hover": {
        background: theme.palette.action.hover,
        "& .g_action": {
          color: theme.palette.primary.main,
        },
      },
      "& > div": {
        flex: 1,
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.grey[200],
      },
    },
  },
  g_table_con_m: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  g_table_item_m: {
    background: theme.palette.grey[700],
    borderRadius: 8,
    padding: 16,
    color: theme.palette.grey[50],
    "& .title_m": {
      color: theme.palette.grey[200],
    },
    "& > div": {
      height: 30,
    },
    "& .g_action": {
      cursor: "pointer",
    },
  },
  g_dialog: {
    fontSize: 14,
    "& .MuiPaper-root": {
      overflow: "hidden",
    },
    "& .MuiDialog-paper": {
      background: "none",
      border: 0,
      width: 500,
      backdropFilter: "none",
      // boxShadow: '0px 4px 32px 0px rgba(0, 0, 0, 0.35)',
      boxShadow: "none",
    },
    "@media screen and (max-width:800px)": {
      "& .MuiPaper-root": {
        background: "none",
        border: 0,
        backdropFilter: "none",
      },
    },
  },
  g_dialog_title: {
    position: "relative",
    padding: "0 24px",
    height: 73,
    "& svg": {
      position: "absolute",
      top: 5,
      left: 0,
      zIndex: -1,
    },
  },
  dialog_title: {
    fontSize: 24,
    fontWeight: 500,
    lineHeight: "33px",
    color: theme.palette.grey[50],
    padding: "20px 0 0",
    display: "block",
  },
  dialog_close: {
    borderRadius: 6,
    background: theme.palette.grey[500],
    color: theme.palette.grey[100],
    display: "flex",
    width: 28,
    height: 28,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    lineHeight: 1,
    margin: "5px 0 0",
  },

  g_dialog_action: {
    gap: 24,
    padding: "0 24px 0px",
    borderLeft: `2px solid ${theme.palette.grey[400]}`,
    borderRight: `2px solid ${theme.palette.grey[400]}`,
    background: theme.palette.grey[500],
    "& button": {
      borderRadius: 16,
    },
  },
  g_dialog_content: {
    background: theme.palette.grey[500],
    borderLeft: `2px solid ${theme.palette.grey[400]}`,
    borderRight: `2px solid ${theme.palette.grey[400]}`,
    padding: "16px 24px 0",
    backdropFilter: "blur(8px)",
  },
  switch: {
    width: 32,
    height: 16,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 12,
      height: 12,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.grey[300],
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  },
  g_page: {
    margin: "40px 0 0",
    display: "flex",
    justifyContent: "flex-end",
    "& .MuiPaginationItem-root": {
      color: theme.palette.grey[100],
      transition: "all .3s ease-in-out",
      "&.Mui-selected": {
        background: theme.palette.grey[400],
      },
      "&:hover": {
        background: theme.palette.grey[400],
      },
      "&.MuiPaginationItem-ellipsis": {
        background: "none",
      },
    },
  },
  g_noresult: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 500,
    flexDirection: "column",
    gap: 16,
    color: theme.palette.grey[300],
  },
  g_out_black: {
    // border: `1px solid ${theme.palette.text[100]}`,
    borderRadius: 5,
    color: theme.palette.sta.text[1],
    fontSize: 16,
    fontWeight: 400,
    whiteSpace: "nowrap",
    "&:hover": {
      // border: `1px solid ${theme.palette.primary.main}`,
      // color: theme.palette.primary.main,
      background: theme.palette.sta.primary.hover,
    },
    "&:active": {
      // border: `1px solid ${theme.palette.primary.m50}`,
      color: theme.palette.primary.m50,
      // background: "none",
    },
  },
});
